
import param from '~/utils/url/param.js'
export default {
  name: 'social-pinterest',
  props: {
    url: {
      type: String,
      async default() {
        return await window.location.href
      }
    }
  },
  methods: {
    open() {
      window.open(
        'https://pinterest.com/pin/create/button' + param({ url: this.url }),
        '__blank'
      )
    }
  }
}
